export type TypingSelectOptions = {
  value: string;
  label: string;
};

export const tipoRegimen: { [key: string]: string } = {
  "": "",
  "Régimen Simplificado": "Régimen Simplificado",
  "Régimen Común": "Régimen Común",
  "Grandes Contribuyentes": "Grandes Contribuyentes",
};

export const tipoPersonaNatural = "NATURAL";
export const tipoPersonaJuridica = "JURIDICA";
export const tipoPersona: { [key: string]: string } = {
  "": "",
  NATURAL: "Persona Natural",
  JURIDICA: "Persona Juridica",
};

export const ListStatusUpdate = [
  // "NUEVO" /*comercio nuevo*/,
  "ACTUALIZAR" /*Esta en el Lado del comercio significa que no se ha llenado el formulario por primera vez*/,
  "CORREGIR" /*Esta en el Lado del comercio significa que el comercio debe corregir algo*/,
  "APROBADO",
  "VALIDAR" /*esta del lado del auditor significa que esta a espera de revision de el auditor*/,
];

export type TypingStatusUpdate =
  | "NUEVO"
  | "ACTUALIZAR"
  | "CORREGIR"
  | "APROBADO"
  | "VALIDAR";

export type TypingStatusUpdateRender = "ACTUALIZAR" | "CORREGIR";

//Aplica la actualizacion de comercios
export type TypingApplyUpdate = "APPLY" | "NO_APPLY_BLACK_LIST_TYPE_COMMERCE";

//Razones por la que se bloquea el comercio en este proyecto
export type TypingBlockedReason = "BLOQUEADO ACTUALIZAR COMERCIO" | null;

export type TypingDataInterno = {
  value: any;
  check: boolean | null;
  nota: string;
  values: { [key: string]: any };
  valueInitial: any;
  valueIsChange: boolean;
};
export type TypingDataInternoString = {
  value: string;
  check: boolean | null;
  nota: string;
  values: { [key: string]: any };
  valueInitial: string;
  valueIsChange: boolean;
};

export type TypingDataInternoNumber = {
  value: number;
  check: boolean | null;
  nota: string;
  values: { [key: string]: any };
  valueInitial: number;
  valueIsChange: boolean;
};

export type TypingDataInternoBoolean = {
  value: boolean;
  check: boolean | null;
  nota: string;
  values: { [key: string]: any };
  valueInitial: boolean;
  valueIsChange: boolean;
};

export type TypingDataInternoDane = {
  value: string;
  check: boolean | null;
  nota: string;
  values: {
    municipio: string;
    departamento: string;
  };
  valueInitial: string;
  valueIsChange: boolean;
};

export type TypingDataInternoAC = {
  value: Array<string>;
  check: boolean | null;
  nota: string;
  values: {
    nombre: Array<string>;
  };
  valueInitial: Array<string>;
  valueIsChange: boolean;
};

export type TypingDataInternoUrl = {
  value: string;
  check: boolean | null;
  nota: string;
  values: {
    nombre: string;
  };
  valueInitial: string;
  valueIsChange: boolean;
};

export type TypingDataAll = {
  "comercio|tipo_documento": TypingDataInternoNumber;
  "comercio|documento": TypingDataInternoString;
  "comercio|actividad_economica": TypingDataInternoAC;
  "comercio|direccion": TypingDataInternoString;
  "comercio|barrio": TypingDataInternoString;
  "comercio|dane": TypingDataInternoDane;
  "comercio|ingresos": TypingDataInternoString;
  "comercio|egresos": TypingDataInternoString;
  "comercio|activos": TypingDataInternoString;
  "comercio|pasivos": TypingDataInternoString;
  "propietario|nombre": TypingDataInternoString;
  "propietario|apellido": TypingDataInternoString;
  "propietario|tipo_documento": TypingDataInternoNumber;
  "propietario|documento": TypingDataInternoString;
  "propietario|lugar_expedicion": TypingDataInternoDane;
  "propietario|fecha_expedicion": TypingDataInternoString;
  "propietario|lugar_nacimiento": TypingDataInternoDane;
  "propietario|fecha_nacimiento": TypingDataInternoString;
  "propietario|direccion": TypingDataInternoString;
  "propietario|barrio": TypingDataInternoString;
  "propietario|residencia": TypingDataInternoDane;
  "propietario|celular": TypingDataInternoString;
  "propietario|correo": TypingDataInternoString;
  "propietario|tipo_persona": TypingDataInternoString;
  "propietario|regimen": TypingDataInternoString;
  "propietario|actividad_economica": TypingDataInternoAC;
  "propietario|check_transacciones_internacionales": TypingDataInternoBoolean;
  "propietario|check_persona_expuesta_publicamente": TypingDataInternoBoolean;
  "propietario|check_declaro_recursos": TypingDataInternoBoolean;
  "propietario|check_declaro_destino": TypingDataInternoBoolean;
  "propietario|url_rut": TypingDataInternoUrl;
  "propietario|url_documento": TypingDataInternoUrl;
  "propietario|url_camara_comercio": TypingDataInternoUrl;
  "propietario|porcentaje": TypingDataInternoString;
  "nota|socios|cant": TypingDataInternoNumber;
};

export type TypingDataSociosInd = {
  nombre: TypingDataInternoString;
  apellido: TypingDataInternoString;
  tipo_documento: TypingDataInternoNumber;
  documento: TypingDataInternoString;
  porcentaje: TypingDataInternoString;
};

export const dataInputAllInitial: TypingDataAll = {
  "comercio|tipo_documento": {
    value: 0,
    check: null,
    nota: "",
    values: {},
    valueInitial: 0,
    valueIsChange: true,
  },
  "comercio|documento": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|actividad_economica": {
    value: [],
    check: null,
    nota: "",
    values: {
      nombre: [],
    },
    valueInitial: [],
    valueIsChange: true,
  },
  "comercio|direccion": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|barrio": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|dane": {
    value: "",
    check: null,
    nota: "",
    values: {
      municipio: "",
      departamento: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|ingresos": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|egresos": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|activos": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "comercio|pasivos": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|nombre": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|apellido": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|tipo_documento": {
    value: 0,
    check: null,
    nota: "",
    values: {},
    valueInitial: 0,
    valueIsChange: true,
  },
  "propietario|documento": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|lugar_expedicion": {
    value: "",
    check: null,
    nota: "",
    values: {
      municipio: "",
      departamento: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|fecha_expedicion": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|lugar_nacimiento": {
    value: "",
    check: null,
    nota: "",
    values: {
      municipio: "",
      departamento: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|fecha_nacimiento": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|direccion": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|barrio": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|residencia": {
    value: "",
    check: null,
    nota: "",
    values: {
      municipio: "",
      departamento: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|celular": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|correo": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|tipo_persona": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|regimen": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|actividad_economica": {
    value: [],
    check: null,
    nota: "",
    values: {
      nombre: [],
    },
    valueInitial: [],
    valueIsChange: true,
  },
  "propietario|check_transacciones_internacionales": {
    value: false,
    check: null,
    nota: "",
    values: {},
    valueInitial: false,
    valueIsChange: true,
  },
  "propietario|check_persona_expuesta_publicamente": {
    value: false,
    check: null,
    nota: "",
    values: {},
    valueInitial: false,
    valueIsChange: true,
  },
  "propietario|check_declaro_recursos": {
    value: false,
    check: null,
    nota: "",
    values: {},
    valueInitial: false,
    valueIsChange: true,
  },
  "propietario|check_declaro_destino": {
    value: false,
    check: null,
    nota: "",
    values: {},
    valueInitial: false,
    valueIsChange: true,
  },
  "propietario|url_rut": {
    value: "",
    check: null,
    nota: "",
    values: {
      nombre: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|url_documento": {
    value: "",
    check: null,
    nota: "",
    values: {
      nombre: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|url_camara_comercio": {
    value: "",
    check: null,
    nota: "",
    values: {
      nombre: "",
    },
    valueInitial: "",
    valueIsChange: true,
  },
  "propietario|porcentaje": {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueInitial: "",
    valueIsChange: true,
  },
  "nota|socios|cant": {
    value: 0,
    check: null,
    nota: "",
    values: {},
    valueInitial: 0,
    valueIsChange: true,
  },
};

export const dataInputSocioIndInitial: TypingDataSociosInd = {
  nombre: {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueIsChange: true,
    valueInitial: "",
  },
  apellido: {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueIsChange: true,
    valueInitial: "",
  },
  tipo_documento: {
    value: 0,
    check: null,
    nota: "",
    values: {},
    valueIsChange: true,
    valueInitial: 0,
  },
  documento: {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueIsChange: true,
    valueInitial: "",
  },
  porcentaje: {
    value: "",
    check: null,
    nota: "",
    values: {},
    valueIsChange: true,
    valueInitial: "",
  },
};
export const dataInputSociosInitial: TypingDataSociosInd[] = Array(99)
  .fill(1)
  .map(() => dataInputSocioIndInitial);

export const getTipoDocumentoOptions = (
  tipoDocumentoOptions_: TypingSelectOptions[],
  value_: number
): string => {
  const encontrado = tipoDocumentoOptions_.find(
    (ind: TypingSelectOptions) => parseInt(ind?.value) === value_
  );
  return encontrado ? encontrado?.label : "";
};
